import { Box, TextField, Button } from '@mui/material';
import { PrimaryButton } from 'mbd-components/primary-button';
import { Text } from 'mbd-components/text';

export function ItemInput ({itemType, value, onChange, onPreview, onAdd}) {
  
  return (
  <Box>
      <Text variant='fieldHeading' color='brand-light'>
          Add {itemType === 'items' ? 'items' : 'users'} to global exclude list
      </Text>
      <Box sx={{ mt: 2, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center' }}>
          <TextField
              label={itemType === 'items' ? 'Item ID' : 'User ID'}
              variant="outlined"
              value={value}
              onChange={onChange}
              sx={{ flexGrow: 1}} 

          />
          <Box mx={2}>
              <Button onClick={onPreview} >
                  Preview
              </Button>
          </Box>
          <PrimaryButton onClick={onAdd}>
              Add to List
          </PrimaryButton>
      </Box>
  </Box>
  )
}